import { useEffect } from 'react'
import {
  closePaywall,
  CreditPusherHandler,
  fetchBusinessBilling,
  Paywall,
  selectPaywallState,
  SubscriptionPusherHandler,
  TopUpModal,
} from 'modules/billing'
import { selectBusinessId } from 'modules/authentication'
import { selectIsLoggedIn } from 'modules/common'
import { useAppDispatch, useAppSelector } from 'modules/core'
import { Navigate } from 'react-router-dom'
import { AppLayout } from 'modules/creative/layouts/AppLayout'
import { AppCommandPalette } from 'modules/creative/components/AppCommandPalette'
import { ChatPusherHandler } from 'modules/creative/components/ChatPusherHandler'
import { usePostPusher } from 'modules/creative/hooks/usePostPusher'
import { ReferralRewardCelebration } from 'modules/referrals/ReferralRewardCelebration'
import { RefereeWelcomeCelebration } from 'modules/referrals/RefereeWelcomeCelebration'
import { useRedirectUrl } from './hooks'

export const AuthAppLayout = () => {
  const isLoggedIn = useAppSelector(selectIsLoggedIn)
  const { showPaywall, source } = useAppSelector(selectPaywallState)
  const dispatch = useAppDispatch()
  const { redirectUrl } = useRedirectUrl()
  const businessId = useAppSelector(selectBusinessId)

  // Listen for autopilot/post Pusher events globally so creative data
  // stays fresh regardless of which page the user is on.
  usePostPusher()

  useEffect(() => {
    if (businessId) {
      dispatch(fetchBusinessBilling(businessId))
    }
  }, [dispatch, businessId])

  if (!isLoggedIn) {
    return <Navigate to={`/login?redirectUrl=${redirectUrl}`} replace />
  }

  const handleClosePaywall = () => dispatch(closePaywall())

  return (
    <>
      <CreditPusherHandler />
      <SubscriptionPusherHandler />
      <ChatPusherHandler />
      <AppLayout />
      <AppCommandPalette />
      <Paywall
        isOpen={showPaywall}
        onClose={handleClosePaywall}
        source={source ?? undefined}
        allowClose
      />
      <TopUpModal />
      {/* Global mount for approved-but-unclaimed referral rewards — auto-claims
          when the user has a single business (toast only), or opens a picker
          dialog when they have multiple. Renders null in the common case. */}
      <ReferralRewardCelebration />
      {/* One-time celebration for the invited friend: fires once after their
          referee credits land, keyed by userId in localStorage. */}
      <RefereeWelcomeCelebration />
    </>
  )
}
